export class Supervisor {
  id: string;
  itemId: string;
  name: string;
  shift: string;
  email: string;
  c1label: string;
  c2label: string;
  c3label: string;
  c4label: string;
  c5label: string;
  c6label: string;
  amStartH: any;
  amStartM: any;
  amEndH: any;
  amEndM: any;
  pmStartH: any;
  pmStartM: any;
  pmEndH: any;
  pmEndM: any;
  mnStartH: any;
  mnStartM: any;
  mnEndH: any;
  mnEndM: any;
  c4StartH: any;
  c4StartM: any;
  c4EndH: any;
  c4EndM: any;
  c5StartH: any;
  c5StartM: any;
  c5EndH: any;
  c5EndM: any;
  c6StartH: any;
  c6StartM: any;
  c6EndH: any;
  c6EndM: any;
  agencyRequirements: string;
  phone: any;
  siteAddress: any;
  isMon: any;
  isTues: any;
  isWed: any;
  isThurs: any;
  isFri: any;
  isSat: any;
  isSun: any;
  siteName: any;
  branch: any;
  startTime: any;
  endTime: any;
  leaderTitle: string;
}
